<template>
    <div>
        <b-button @click="addType">Add Process</b-button>
        <b-modal
            v-model="itemModal"
            id="item-modal"
            :title="(model.id ? 'Edit' : 'Add') + ' Type'"
            @ok="saveTemplateType"
        >
            <b-form bg-variant="light">
                <b-form-group
                    id="sequence_no-group"
                    label="Sequence No:"
                    label-for="input-sequence_no"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="number"
                        id="input-sequence_no"
                        v-model="model.sequence_no"
                        required
                        placeholder="Sequence Number"
                        trim
                    ></b-form-input>
                </b-form-group>

                <!-- <b-form-group
                    id="previous_sequence_no-group"
                    label="Previous Number:"
                    label-for="input-previous_sequence_no"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="number"
                        id="input-previous_sequence_no"
                        v-model="model.previous_sequence_no"
                        required
                        placeholder="Enter Previous Number"
                        trim
                    ></b-form-input>
                </b-form-group> -->

                <b-form-group
                    id="checkoff_type_id-group"
                    label="Review Type:"
                    label-for="input-checkoff_type_id"
                    label-cols="4"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-checkoff_type_id"
                        v-model="model.checkoff_type_id"
                        :options="types"
                        text-field="name"
                        value-field="id"
                        required
                        trim
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >-- Please Select the Review Type
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-form>
            <template #modal-footer="{ ok, cancel }">
                <b-button-group size="sm">
                    <b-button variant="success" @click="ok()">
                        {{
                            `${
                                !!model.index || !!model.id
                                    ? 'Update'
                                    : 'Create'
                            } Type`
                        }}
                    </b-button>
                    <b-button
                        v-if="!!model.id || !!model.index"
                        variant="danger"
                        @click="deleteTemplateType()"
                    >
                        Delete
                    </b-button>
                    <b-button variant="warning" @click="cancel()">
                        Cancel
                    </b-button>
                </b-button-group>
            </template>
        </b-modal>

        <b-table striped hover :items="templateTypes" :fields="itemFields">
            <template #cell(id)="{ value }">
                <b-button
                    size="sm"
                    @click="viewType(value)"
                    class="mr-2"
                    variant="primary"
                >
                    Select
                </b-button>
            </template>
        </b-table>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    props: ['template'],
    mixins: [popupMixins],
    data() {
        return {
            itemFields: [
                {
                    key: 'id',
                    label: '',
                },

                {
                    key: 'sequence_no',
                    label: 'Sequence',
                },
                /*   {
                    key: 'previous_sequence_no',
                    label: 'Prev',
                }, */

                {
                    key: 'checkoff_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.checkoff_type.name,
                },
            ],
            model: {
                id: null,
                checkoff_type_id: null,
                sequence_no: null,
                previous_sequence_no: null,
            },
            loading: false,
            itemModal: false,
            modelChanged: false,
        }
    },
    computed: {
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },

        types() {
            const items = this.$store.state.checkoffTypes.types
            console.log('items', items)
            return items
        },
        templateTypes() {
            const _templateTypes = (this.template && this.template.types) || []
            _templateTypes.sort((a, b) => a.sequence_no - b.sequence_no)
            return _templateTypes
        },
    },
    watch: {},

    methods: {
        addType() {
            this.model = {
                id: null,
                previous_sequence_no: null,
                sequence_no: null,
                checkoff_type_id: null,
            }
            this.itemModal = true
        },
        async viewType(id) {
            /* if the template exists find the item among the template's 
            types otherwise, firnd the item among the template model's types */
            const templateType =
                this.template.types.find(x => x.id === id) || {}
            this.model = { ...templateType }
            this.itemModal = true
        },
        async deleteTemplateType() {
            // if the template exists delete the master item from the database

            const path = `checkoffTemplates/deleteType`
            const template_id = this.template.id
            const item_id = this.model.id

            try {
                this.loading = true
                await this.$store.dispatch(path, { template_id, item_id })
                this.itemModal = false
                this.modelChanged = false
            } catch (error) {
                console.log('error', error)
                this.doToast('Error Detected', error.message, 'warning')
            } finally {
                this.loading = false
            }
        },

        async saveTemplateType(bvModalEvt) {
            bvModalEvt.preventDefault()

            const item = { ...this.model }

            console.log('model item', item)

            item.previous_sequence_no = item.previous_sequence_no || 0
            const template_id = this.template.id
            const model = { template_id, item }

            // if the template exists add the master item to the template in the database or update it in the database
            const path = `checkoffTemplates/${
                parseInt(item.id) ? 'updateType' : 'createType'
            }`

            try {
                this.loading = true
                await this.$store.dispatch(path, model)
                this.loading = false
                this.itemModal = false
                this.modelChanged = false
            } catch (error) {
                console.log('error', error)
                let message = error.message
                if (
                    message.indexOf('insert into `checkoff_template_types') >= 0
                ) {
                    message = 'Duplicate Type Entry'
                }
                this.doToast('Error Detected', message, 'warning')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
